/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const FEEDBACK_QUESTION_GROUPS = [
  {
    id: 'understanding',
    questionStringId: 'command_intelligence_feedback_question_understanding',
    sectionLabelStringId: 'command_intelligence_feedback_section_understanding',
    choices: [
      {
        value: 'misunderstood_task',
        labelStringId: 'command_intelligence_feedback_choice_misunderstood_task',
      },
      {
        value: 'ignored_constraint',
        labelStringId: 'command_intelligence_feedback_choice_ignored_constraint',
      },
      {
        value: 'wrong_scope',
        labelStringId: 'command_intelligence_feedback_choice_wrong_scope',
      },
      {
        value: 'none',
        labelStringId: 'command_intelligence_feedback_choice_none',
      },
    ],
  },
  {
    id: 'readability',
    questionStringId: 'command_intelligence_feedback_question_readability',
    sectionLabelStringId: 'command_intelligence_feedback_section_readability',
    choices: [
      {
        value: 'visually_hard_to_read',
        labelStringId: 'command_intelligence_feedback_choice_visually_hard_to_read',
      },
      {
        value: 'wrote_too_much',
        labelStringId: 'command_intelligence_feedback_choice_wrote_too_much',
      },
      {
        value: 'explanation_not_trustworthy',
        labelStringId: 'command_intelligence_feedback_choice_explanation_not_trustworthy',
      },
      {
        value: 'none',
        labelStringId: 'command_intelligence_feedback_choice_none',
      },
    ],
  },
];
